import ScheduleWeek from './ScheduleWeek';

export default ScheduleWeek;
